<template>
  <div class="status-select-box">
    <v-select
        v-model="model"
        :options="computedStatusOptions"
        label="label"
        :reduce="status => status.value"
        :multiple="true"
        :clearable="true"
        :close-on-select="false"
        :deselect-from-dropdown="true"
        v-bind="selectProps"
    >
      <!-- Dropdown header with Select All / Unselect All -->
      <template #list-header>
        <div
            v-if="multiple"
            class="dropdown-actions d-flex justify-content-between align-items-center px-2 py-1"
        >
          <b-button
              size="sm"
              variant="outline-success"
              class="action-btn"
              @mousedown.stop.prevent="selectAll"
          >Select All</b-button>
          <b-button
              size="sm"
              variant="outline-danger"
              class="action-btn"
              @mousedown.stop.prevent="unselectAll"
          >Unselect All</b-button>
        </div>
        <hr class="m-1" />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'StatusSelectBox',
  props: {
    value: { required: true },
    nullable: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    selectProps: { type: Object, default: () => ({}) }
  },
  computed: {
    model: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    computedStatusOptions() {
      const statuses = this.$store.getters['clients/allStatuses'] || [];

      let options = statuses.map(s => ({
        label: s.status,
        value: s.id,
      }));

      if (this.nullable) {
        options = [{ label: 'NOT ASSIGNED', value: null }, ...options];
      }

      return options;
    }
  },
  methods: {
    selectAll() {
      const allIds = this.computedStatusOptions
          .filter(opt => opt.value !== null)
          .map(opt => opt.value);
      this.$emit('input', allIds);
    },
    unselectAll() {
      this.$emit('input', []);
    }
  }
};
</script>

<style scoped>
/* === Reuse the affiliate design for header buttons === */
.dropdown-actions {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.dark-layout .dropdown-actions {
  background-color: rgb(30, 31, 36);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.action-btn {
  min-width: 90px;
  font-size: 0.75rem;
}

</style>
